import React from 'react';
import { Container } from '../../components/ui/Container';
export function ArabicPrivacyPolicy() {
  return <section className="py-16 text-right md:py-24" dir="rtl" data-id="element-3684" data-mp="1vf1npflde13n">
      <Container data-id="element-3685" data-mp="29fuim1fl2y7a">
        <article className="mx-auto max-w-4xl" data-id="element-3686" data-mp="29ge1plgyzsmw">
          <h1 className="font-display text-4xl font-semibold leading-[1.5] text-ink-900 md:text-6xl" data-id="element-3687" data-mp="29f2z3oz9gqxd">
            سياسة الخصوصية
          </h1>
          <p className="mt-4 text-ink-500" data-id="element-3688" data-mp="1gqnn7bbfeoq9">
            <strong data-id="element-3689" data-mp="1grqal99ji91f">آخر تحديث:</strong> 1 فبراير 2026
          </p>

          <div className="mt-10 space-y-8 leading-loose text-ink-700" data-id="element-3690" data-mp="1bsvljpkzbo8v">
            <p data-id="element-3691" data-mp="1qh05ewvrq5t8">
              يلتزم <strong data-id="element-3692" data-mp="1qh9wyowgol11">المركز الدولي للتعلّم الإسلامي (IILH)</strong> التزامًا
              راسخًا بحماية خصوصيتك وضمان أمن بياناتك الشخصية.
            </p>

            <h2 className="mt-12 font-display text-2xl font-semibold leading-[1.5] text-ink-900 md:text-3xl" data-id="element-3693" data-mp="1lo73egropbku">
              جمع البيانات
            </h2>
            <p data-id="element-3694" data-mp="t0kz16amu2wx">
              نجمع البيانات الشخصية اللازمة لتقديم خدماتنا، بما في ذلك على سبيل
              المثال لا الحصر:
            </p>
            <p data-id="element-3695" data-mp="3tiyhcuc9f7a9">
              <strong data-id="element-3696" data-mp="2ermxnwj9jmw">• بيانات الهوية:</strong> الاسم وبيانات الاتصال، مثل البريد
              الإلكتروني ورقم الهاتف والعنوان.
            </p>
            <p data-id="element-3697" data-mp="76j8tl4qv16p">
              <strong data-id="element-3698" data-mp="75zyaphfbf2p">• بيانات الحساب:</strong> اسم المستخدم وكلمة المرور وحالة
              العضوية.
            </p>
            <p data-id="element-3699" data-mp="b95zvjtlci2u">
              <strong data-id="element-3700" data-mp="3am6r20yavrwp">• بيانات الخدمة:</strong> المعلومات المقدَّمة من خلال الطلبات
              والاستفسارات.
            </p>
            <p data-id="element-3701" data-mp="3fkhzq8cuzwdc">
              <strong data-id="element-3702" data-mp="3fmbbg22bx6s7">• البيانات المالية:</strong> المعلومات المتعلقة بالمدفوعات،
              والتي تُعالَج بأمان عبر مزوّدي دفع من جهات خارجية. لا نخزّن بيانات بطاقات
              الائتمان الحساسة على خوادمنا.
            </p>

            <h2 className="mt-12 font-display text-2xl font-semibold leading-[1.5] text-ink-900 md:text-3xl" data-id="element-3703" data-mp="3on9bk99ncu5i">
              كيف نستخدم بياناتك
            </h2>
            <p data-id="element-3704" data-mp="13uxri39iz4xr">نستخدم بياناتك للأغراض المحددة التالية:</p>
            <ul className="list-inside list-disc space-y-2 pr-4" data-id="element-3705" data-mp="13xjxvzkojeee">
              <li data-id="element-3706" data-mp="2zxaoiberxtj3">تقديم البرامج التعليمية والخدمات المجتمعية.</li>
              <li data-id="element-3707" data-mp="2vy1v57nnbxo2">التواصل معك بشأن التحديثات أو الدورات الدراسية أو الإشعارات الإدارية.</li>
              <li data-id="element-3708" data-mp="39xl1pw0t70y9">الوفاء بالتزاماتنا القانونية والإدارية.</li>
              <li data-id="element-3709" data-mp="39uys7qucybde">تحليل الاتجاهات وتحسين جودة خدماتنا.</li>
            </ul>

            <h2 className="mt-12 font-display text-2xl font-semibold leading-[1.5] text-ink-900 md:text-3xl" data-id="element-3710" data-mp="34yhv4756kmo6">
              حماية البيانات ومشاركتها
            </h2>
            <p data-id="element-3711" data-mp="2ca2j7thcikh2">
              <strong data-id="element-3712" data-mp="2cam1jbawravm">الأمان:</strong> نعالج جميع البيانات بصورة قانونية ونستخدم
              التدابير التقنية المناسبة لضمان أمنها.
            </p>
            <p data-id="element-3713" data-mp="2m7gz9rzcx78u">
              <strong data-id="element-3714" data-mp="2m7qnpb4r76cf">عدم بيع البيانات:</strong> لا نبيع بياناتك الشخصية أو نؤجرها أو
              نسيء استخدامها لتحقيق مكاسب تجارية.
            </p>
            <p data-id="element-3715" data-mp="1ygbgp52180uu">
              <strong data-id="element-3716" data-mp="1yftdtpkv6ody">ضبط الوصول:</strong> يقتصر الوصول إلى المعلومات الشخصية على
              الأشخاص المصرّح لهم ممن يحتاجون إليها لأداء مهامهم.
            </p>

            <h2 className="mt-12 font-display text-2xl font-semibold leading-[1.5] text-ink-900 md:text-3xl" data-id="element-3717" data-mp="8zz6o5cvd774">
              الامتثال للائحة GDPR وحقوق المستخدم
            </h2>
            <p data-id="element-3718" data-mp="m5dzywfoxh">وفقًا لمعايير اللائحة العامة لحماية البيانات (GDPR)، يحق لك:</p>
            <p data-id="element-3719" data-mp="41nzy3hvfct4">
              <strong data-id="element-3720" data-mp="4164va6y34ms">• الوصول:</strong> طلب نسخة من البيانات الشخصية التي نحتفظ بها
              عنك.
            </p>
            <p data-id="element-3721" data-mp="rsbkbo8z3uwk">
              <strong data-id="element-3722" data-mp="rrryvxk46ods">• التصحيح والمسح:</strong> طلب تصحيح البيانات غير الدقيقة أو
              حذف بياناتك («الحق في النسيان»).
            </p>
            <p data-id="element-3723" data-mp="iqkcacqynbzj">
              <strong data-id="element-3724" data-mp="ir3mt8ea6y3j">• سحب الموافقة:</strong> سحب موافقتك على معالجة البيانات في أي
              وقت، حيثما ينطبق ذلك.
            </p>
            <p data-id="element-3725" data-mp="no3qxdrklqs0">
              لممارسة هذه الحقوق، يُرجى التواصل مع مسؤول حماية البيانات لدينا عبر:{' '}
              <a href="mailto:privacy@iilh.org" className="font-medium text-forest-700 underline underline-offset-2 transition hover:text-forest-800" dir="ltr" data-id="element-3726" data-mp="33f87vy0hv4zf">
                privacy@iilh.org
              </a>
              .
            </p>
          </div>
        </article>
      </Container>
    </section>;
}